import React from "react";
import { Link } from "react-router-dom";
import LogoAtivaJa from "@/components/LogoAtivaJa";
import { Wrench, Users, Building2, ArrowRight, ArrowLeft } from "lucide-react";

const OPCOES = [
  {
    to: "/cadastro-montador",
    titulo: "Sou Montador",
    desc: "Técnico autônomo que executa montagens. Receba ofertas na sua região, aceite quando quiser e gerencie sua agenda.",
    icon: Wrench,
    destaque: "Cadastro em 4 etapas · contrato digital",
    testid: "cadastro-opcao-montador",
  },
  {
    to: "/cadastro-montadora",
    titulo: "Sou Montadora",
    desc: "Gestora operacional regional. Coordene montadores, acompanhe score da rede e receba repasses por atendimento.",
    icon: Users,
    destaque: "6 meses de gratuidade",
    testid: "cadastro-opcao-montadora",
  },
  {
    to: "/cadastro-empresa",
    titulo: "Sou Empresa",
    desc: "Loja, seguradora ou fabricante. Importe seus atendimentos por planilha e deixe a distribuição automática trabalhar.",
    icon: Building2,
    destaque: "Importação inteligente de planilhas",
    testid: "cadastro-opcao-empresa",
  },
];

export default function EscolhaCadastro() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] font-body">
      <header className="bg-white border-b border-[#E2E8F0]">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" data-testid="cadastro-logo-link"><LogoAtivaJa size="sm" /></Link>
          <Link to="/login" className="text-sm font-semibold text-[#142766] hover:text-[#FF6700] transition-colors" data-testid="cadastro-ja-tenho-conta">
            Já tenho conta
          </Link>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-14">
        <div className="text-center aj-fade-up">
          <div className="aj-eyebrow">Cadastro público</div>
          <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-[#0F172A] mt-2">
            Como você quer usar o <span className="aj-accent-orange">MontaJá</span>?
          </h1>
          <p className="text-[#64748B] mt-3 max-w-xl mx-auto text-sm sm:text-base">
            Escolha o seu perfil para começar. Cada papel tem um painel próprio com as ferramentas certas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 mt-12">
          {OPCOES.map((o, i) => (
            <Link key={o.to} to={o.to} data-testid={o.testid}
              className={`aj-card p-7 flex flex-col group hover:-translate-y-1 transition-transform aj-fade-up-${i + 1}`}>
              <div className="aj-icon-tile mb-5"><o.icon size={22} /></div>
              <div className="font-display font-extrabold text-xl text-[#142766]">{o.titulo}</div>
              <p className="text-sm text-[#64748B] mt-2 flex-1">{o.desc}</p>
              <div className="mt-4 text-[11px] font-bold uppercase tracking-wider text-[#E05C00] bg-[#FFF3E0] rounded-md px-2 py-1 inline-block self-start">
                {o.destaque}
              </div>
              <div className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-[#FF6700] group-hover:gap-3 transition-all">
                Começar cadastro <ArrowRight size={16} />
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#64748B] hover:text-[#142766] transition-colors" data-testid="cadastro-voltar-home">
            <ArrowLeft size={15} /> Voltar para o início
          </Link>
        </div>
      </main>
    </div>
  );
}
